module.exports = __webpack_public_path__ + "img/Subtract.2ba17e3f.svg";